var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5597 2.43843C18.3412 1.62673 17.7012 0.986745 16.8895 0.768212C15.4066 0.362366 9.47496 0.362366 9.47496 0.362366C9.47496 0.362366 3.54335 0.362366 2.06045 0.752603C1.26437 0.971136 0.60877 1.62673 0.390237 2.43843C0 3.92133 0 6.9964 0 6.9964C0 6.9964 0 10.0871 0.390237 11.5544C0.60877 12.3661 1.24876 13.0061 2.06045 13.2246C3.55896 13.6304 9.47496 13.6304 9.47496 13.6304C9.47496 13.6304 15.4066 13.6304 16.8895 13.2402C17.7012 13.0217 18.3412 12.3817 18.5597 11.57C18.9499 10.0871 18.9499 7.01201 18.9499 7.01201C18.9499 7.01201 18.9655 3.92133 18.5597 2.43843Z",
    fill: "#C0C3C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58594 4.15631V9.83816L12.5185 6.99724L7.58594 4.15631Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.575edd3e0a7552d28693d440d986b4d8.svg";
export { ForwardRef as ReactComponent };